__turbopack_context__.v({
  "image": "Image-module-scss-module__cKnT8q__image",
  "image-container": "Image-module-scss-module__cKnT8q__image-container",
});
